module.exports = __webpack_public_path__ + "img/vod-00.c4926523.jpg";